import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Progetti from "@/pages/Progetti";
import Immagini from "@/pages/Immagini";
import Privacy from "@/pages/Privacy";
import Sostienici from "@/pages/Sostienici";
import Contatti from "@/pages/Contatti";
import Accedi from "@/pages/Accedi";
import AreaSoci from "@/pages/AreaSoci";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/progetti" element={<Progetti />} />
        <Route path="/immagini" element={<Immagini />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/trasparenza" element={<Navigate to="/area-soci" replace />} />
        <Route path="/sostienici" element={<Sostienici />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/accedi" element={<Accedi />} />
        <Route path="/area-soci" element={<AreaSoci />} />
      </Route>
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AppRoutes />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
